import {
    SESSION_LIST_REQUEST,
    SESSION_LIST_RESPONSE,
    SESSION_LIST_CACHED_RESPONSE,
    SESSION_LIST_ERROR_RESPONSE
} from "../actions/action-types"

import {
    sessionListResponse,
    sessionListCachedResponse,
    sessionListErrorResponse
} from "../actions/session-actions"

import {
    requestListEpic,
    callbackActionCreatorEpic
} from "./default-epics/default-entity-epics"

import { getSessionList } from "../api/session-api"

export const requestSessionListEpic = requestListEpic(
    SESSION_LIST_REQUEST,
    getSessionList,
    "sessions",
    sessionListResponse,
    sessionListCachedResponse,
    sessionListErrorResponse
)

export const responseUserCallbackEpic = callbackActionCreatorEpic(
    SESSION_LIST_RESPONSE,
    SESSION_LIST_CACHED_RESPONSE,
    SESSION_LIST_ERROR_RESPONSE
)
